import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { RedoMerchantRpcClientContext } from "../rpc-client";

export function useTeamMarketingProviders() {
  return useRpcQuery(
    RedoMerchantRpcClientContext,
    "getMarketingEcommerceProviders",
    {},
  );
}
